module.exports = __webpack_public_path__ + "fonts/pt_root-ui_light.d12f282.woff2";